import { createAction } from "@reduxjs/toolkit";

export const setError = createAction('error/setError');
export const hideError = createAction('error/hideError');